import { parse } from 'iso8601-duration'

export const parseDuration = (durationString: string): string => {
  const duration = parse(durationString)

  return Object.keys(duration)
    .filter((designator) => duration[designator] > 0)
    .map((designator) => {
      const unit = duration[designator]
      const pluralisedDesignator = unit > 1 ? designator : designator.slice(0, -1)

      return `${unit} ${pluralisedDesignator}`
    })
    .join(', ')
}
